import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { dataForCreateVacancyModal } from '../../../../utils/checkBeforeCreate';

const initialState: any = {
	limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
	pages: 1,
	page: 1,
	data: [],
	vacancyCreateInputValues: {
		type: 'NO_ROUTE',
	},
};

export const createVacancySlice = createSlice({
	name: 'createVacancy',
	initialState,
	reducers: {
		reducerCreateVacancyInputValues: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			if (action.payload.projects) {
					const projectRoutes = action.payload.routesNo
					? dataForCreateVacancyModal(action.payload.routesNo, action.payload.projects)
					: action.payload.projects.map((el: any) => ({ project: el }));

				state.vacancyCreateInputValues = { ...action.payload, projectRoutes };
			} else {
				state.vacancyCreateInputValues = action.payload;
			}
		},
		reducerSelectedVacancyRoutes: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.selectedRoutes = action.payload;
		},
		reducerHandleErrors: (state: Draft<any>, action: PayloadAction<any>) => {
			state.errors = action.payload;
		},
		reducerAddRoutesListOptions: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			const { routes, vacancyCreateInputValues } = action.payload;

			let filteredRoutes = []

			if (!vacancyCreateInputValues.project) {
				filteredRoutes = routes
			} else {
				const filteredByProjectRoutes = routes.filter((el: any) => el.project.id === vacancyCreateInputValues.project.id)
				filteredRoutes = filteredByProjectRoutes;
			}

			const allowedTypes = ['ReplacementNoVacancy', 'ActiveNoVacancy', 'VacantNoVacancy']

			const temp = filteredRoutes.filter((el: any) => {
				return (
					el.routeStatusType &&
					allowedTypes.some(status =>
						Object.keys(el.routeStatusType).includes(status)
					)
				);
			});

			state.availableRoutes = temp

			state.routesListOptions = temp.map((el: any) => {
				return { value: el, label: el.routeNo };
			});
			state.routesListOptions.sort((a: any, b: any) => a.value - b.value);

		},
	},
});

export const {
	reducerCreateVacancyInputValues,
	reducerSelectedVacancyRoutes,
	reducerHandleErrors,
	reducerAddRoutesListOptions,
} = createVacancySlice.actions;

export default createVacancySlice.reducer;
